/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'ptc.pm.collaborators.title': 'あなたのコラボレーター',
  'ptc.pm.error-heading': '問題が発生しました。',
  'ptc.pm.error-image-alt-text': '速やかに復旧するよう対応中です。',
  'ptc.pm.error-text': 'これらのエラーは監視していますが、更新しても問題が解決しない場合はご遠慮なくお知らせください。',
  'ptc.pm.num-members': '{memberCount, plural, other {{memberCount,number} 人のメンバー}}',
  'ptc.pm.people': 'ユーザー',
  'ptc.pm.teams': 'チーム',
  'ptc.pm.view-your-profile': 'プロフィールを表示',
  'ptc.pm.your-teams.title': 'あなたのチーム',
};
